import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonLoaderProps {
    wrapperClassName?: string;
    className?: string;
    count?: number;
}

function SkeletonLoader({ wrapperClassName, className, count }: SkeletonLoaderProps) {
    return (
        <div className={wrapperClassName}>
            <Skeleton count={count} className={className} />
        </div>
    );
}

export default SkeletonLoader;
